// React
import React from 'react'
import { ThemeProvider, StyleSheetManager } from 'styled-components'

// Shared
import theme from 'ui/themes/public'
import getBrandingColor from 'shared/utils/getBrandingColor'
import { shouldForwardProp } from 'shared/utils/shouldForwardProp'

const withTheme = (Component) => {
  const WithThemeProvider = (props) => {
    return (
      <ThemeProvider theme={theme(getBrandingColor())}>
        <StyleSheetManager shouldForwardProp={shouldForwardProp} enableVendorPrefixes>
          <Component {...props} />
        </StyleSheetManager>
      </ThemeProvider>
    )
  }

  WithThemeProvider.displayName = `WithTheme(${Component.displayName || Component.name || 'Component'})`

  return WithThemeProvider
}

export default withTheme
